import React from "react";
import styles from "./styles.module.scss";

export const LoadingBallsVW = () => (
  <div className={styles.root}>
    <div className={`${styles.spinner} ${styles.balls}`}></div>
  </div>
);
